import { Info } from "@phosphor-icons/react";
import clsx from "clsx";

import IconAvatar from "common/components/IconAvatar";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";

import type { JSX } from "react";

export default function SectionHeading({
  title,
  description,
  icon,
  shouldShowMobileTooltip,
}: {
  title: string;
  description: string;
  icon: JSX.Element;
  shouldShowMobileTooltip: boolean;
}) {
  return (
    <div className="flex items-center gap-2.5">
      <IconAvatar>{icon}</IconAvatar>

      <div className="flex flex-col gap-y-1">
        <div className="flex items-center gap-x-1">
          <h3 className="lg:text-md-bold text-sm-bold">{title}</h3>
          {shouldShowMobileTooltip && (
            <Tooltip>
              <TooltipTrigger className="lg:hidden">
                <Info weight="fill" className="size-4 text-black-300" />
              </TooltipTrigger>
              <TooltipContent>{description}</TooltipContent>
            </Tooltip>
          )}
        </div>
        <p
          className={clsx(
            "text-xs-medium text-black-500",
            shouldShowMobileTooltip && "max-lg:hidden",
          )}
        >
          {description}
        </p>
      </div>
    </div>
  );
}
